import React, { Component } from 'react';
import PropTypes from 'prop-types';
import VipStore from './stores/VipStore';
import { VipIntro, VipWorks, VipSubscription } from './components/vip';
import { VipSettingsContainer } from './containers';

class VipApp extends Component {
  componentDidMount() {
    const { vipOn, vipName, vipIcon } = this.props;

    VipStore.setVipOn(vipOn);
    VipStore.setVipName(vipName);
    VipStore.setVipIcon(vipIcon);
    VipStore.emitChange();
  }

  render() {
    const { vipSubscribed } = this.props;

    return (
      <div className="vip block">
        <VipSettingsContainer
          vipSubscribed={vipSubscribed}
        />
      </div>
    );
  }
}

VipApp.propTypes = {
  vipSubscribed: PropTypes.bool,
  vipOn: PropTypes.bool,
  vipName: PropTypes.string,
  vipIcon: PropTypes.bool,
};

VipApp.defaultProps = {
  vipSubscribed: false,
  vipOn: false,
  vipName: '',
  vipIcon: false,
};

export default VipApp;
